import Vue from 'vue'

export function showSuccessMessage(message) {
  if (message) {
    Vue.notify({
      group: 'default',
      title: message,
      type: 'success',
      duration: 3000
    })
  }
}

export function showErrorMessage(message = 'Something went wrong') {
  Vue.notify({
    group: 'default',
    title: message,
    type: 'error',
    duration: 5000
  })
}

/**
 * What to tell the user about a failed API call: the server's own `title` when it sent one, the
 * caller's `fallback` otherwise - and always for a 500, whose title is not meant for the user.
 */
export function getApiErrorMessage(error, fallback) {
  const title = error?.response?.data?.title

  return error?.response?.status === 500 || !title ? fallback : title
}

export function showWarningMessage(message) {
  if (message) {
    Vue.notify({
      group: 'default',
      title: message,
      type: 'warn',
      duration: 5000
    })
  }
}

export function showInfoMessage(message) {
  if (message) {
    Vue.notify({
      group: 'default',
      title: message,
      type: 'info',
      duration: 5000
    })
  }
}